import request from "../axios";

// 获取app信息
export function getAppInfo(abbreviation) {
    return request({
        url: "/api/inf/queryByAbbreviation",
        method: "get",
        params: { abbreviation: abbreviation }
    })
}

// 注册
export function register(data) {
    return request({
        url: "/api/user/register",
        method: "post",
        data
    })
}

// 获取验证码
export function getSmsCode(data) {
    return request({
        url: "/api/user/sendMsgCode",
        method: "post",
        data
    })
}

// 校验手机号是否存在
export function preValidMobile(data) {
    return request({
        url: "/api/user/preValidMobile",
        method: "post",
        data
    })
}

// 获取小程序URL Scheme
export function getUrlScheme() {
    return request({
      url: '/api/user/genSchemeMa',
      method: 'get'
    })
}